<div class="d-flex justify-content-center commande-header_labels mb-4">
  <div class="col-3">
    <strong>Ma commande</strong>
  </div>

  <div class="col-3">
    <strong>
      Mes informations <br />
      administratives
    </strong>
  </div>

  <div class="col-3">
    <strong>Ma validation</strong>
  </div>
</div>

<div class="row justify-content-center">
  <div class="col-9">
    <div class="progress rounded-5 shadow bg-white">
      <div
        class="progress-bar bg-primary rounded-5"
        role="progressbar"
        aria-label="Commande de crédit progress bar"
        [attr.style]="'width:' + widthProgresBar + '%'"
        [attr.aria-valuenow]="widthProgresBar"
        aria-valuemin="0"
        aria-valuemax="100"
      ></div>
    </div>
  </div>
</div>
